/**
 * The console's Cognito sign-in (login-console-signin): OUR OWN SCREEN (owner,
 * 2026-10-19), on the shared module in @bioweave/api-client/cognito. The browser calls
 * Cognito's API directly with the console's public client: an emailed code, no password,
 * no hosted page.
 */
import { cognitoPool as readPool, makeRefreshStore, type CognitoPool } from '@bioweave/api-client/cognito';

export {
  CognitoAuthError, refreshWith, revoke, startSignIn, submitCode,
  type AuthErrorKind, type CodeChallenge, type CognitoPool, type Tokens,
} from '@bioweave/api-client/cognito';

/** Off unless VITE_COGNITO_REGION and VITE_COGNITO_CLIENT_ID are set: the console then
 *  signs in with a pasted token only, as before. */
export function cognitoPool(): CognitoPool | null {
  return readPool(import.meta.env as unknown as Record<string, string | boolean | undefined>);
}

/** PER SESSION (owner, 2026-10-19, relayed by PC): the console sees every user's data,
 *  so its sign-in ends with the tab rather than lasting the refresh token's 30 days. */
export const refreshStore = makeRefreshStore('bioweave_console_cognito_refresh',
                                             () => globalThis.sessionStorage);
